import { Outlet } from 'react-router-dom';

import { CookieConsent } from '@/components/CookieConsent/CookieConsent';
import { ScrollToTop } from '@/components/ScrollToTop';
import { useAuthErrorHandler } from '@/hooks/useAuthErrorHandler';
import { useTrackingScripts } from '@/hooks/useTrackingScripts';

// Side-effect-only layout mounted at the top of the router tree. Runs the
// auth-error hash handler exactly once at app boot and resets scroll on
// every route change. `useNavigate` requires a Router ancestor, so this
// lives inside `RouterProvider` (AppProviders is outside it). All real
// layouts render through `<Outlet />` below.
export function AppRoot() {
  useAuthErrorHandler();
  useTrackingScripts();
  return (
    <>
      <ScrollToTop />
      <Outlet />
      <CookieConsent />
    </>
  );
}
